
import React from 'react';



function UserProofRow2({ value, onClick }) {
  
  return (
    <div className="row mt-2">
      
      {value && <div className="col-md-12">Approved Application : <button className="button2" onClick={onClick}>View uploaded ID Proof</button></div> }
      


    </div>
  );
}

export default UserProofRow2;